import {Box, Flex, Text} from '@chakra-ui/layout'
import React from 'react'
import {NavLink, useLocation, useRouteMatch} from 'react-router-dom'
import Logo from '../../utilities/Logo';
import {Link} from "@chakra-ui/react";
import AuthLink from "../../layout/AuthLink";

export default function AuthHome() {
  let {path, url} = useRouteMatch();
  let {pathname} = useLocation();
  console.log(path, url, pathname);
  return (
    <Box>
      <Logo _fontSize={"3rem"} _mt={8}/>
      <Flex flexDirection={"column"} textAlign={"center"}>
        <AuthLink name={"sign up"} studentLink={`${url}/student/signup`} tutorLink={`${url}/tutor/signup`}/>
        <AuthLink name={"login"} studentLink={`${url}/student/login`} tutorLink={`${url}/tutor/login`}/>
      </Flex>
    </Box>
  )
}
